export const trimAllObjectSpaces = (obj: any = {}) => JSON.parse(JSON.stringify(obj).replace(/"\s+|\s+"/g, '"'))
